import React, { useState } from 'react';
import PackageCarousel from './PackageCarousel';
import { usePackages, useSettings, getInternational, getIndia } from '../store';
import { Briefcase, MapPin } from 'lucide-react';

const Bestsellers = () => {
  const [tab, setTab] = useState('international');
  const { packages } = usePackages();
  const settings = useSettings();
  const items = tab === 'international' ? getInternational(packages) : getIndia(packages);

  return (
    <section className="py-14">
      <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
        <div className="flex items-end justify-between mb-6 flex-wrap gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-900">
              {(settings.section_bestsellers_title || 'Bestsellers').split(' ').map((w, i, arr) => (
                <span key={i}>{i === arr.length - 1 ? <span className="text-[#0d64a8]">{w}</span> : w + ' '}</span>
              ))}
            </h2>
            <p className="text-sm text-gray-500 mt-1">Handpicked packages loved by travellers</p>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => setTab('international')}
              className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition ${
                tab === 'international' ? 'bg-[#0d64a8] text-white' : 'bg-white text-gray-700 border border-gray-200 hover:border-[#0d64a8]'
              }`}
            >
              <Briefcase size={15} /> International Tours
            </button>
            <button
              onClick={() => setTab('india')}
              className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition ${
                tab === 'india' ? 'bg-[#0d64a8] text-white' : 'bg-white text-gray-700 border border-gray-200 hover:border-[#0d64a8]'
              }`}
            >
              <MapPin size={15} /> India Tours
            </button>
          </div>
        </div>

        <PackageCarousel items={items} />
      </div>
    </section>
  );
};

export default Bestsellers;
